// components/GoogleLoginButton.tsx
import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import useAuth from 'src/hooks/useAuth';
import { BASE_URL } from 'src/utils/constant';


interface GoogleCredentialResponse {
    credential: string;
}

const GoogleLoginButton = () => {
    const auth = useAuth();
    const handleSuccess = async (response: GoogleCredentialResponse) => {
        const { credential } = response;
        const decoded: any = jwtDecode(credential);
        // 

        // You can send this decoded info or token to Laravel
        const res = await fetch(`${BASE_URL}api/auth/google`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token: credential,
                email: decoded.email,
                name: decoded.name,
                avatar: decoded.picture,
            }),
        });

        const result = await res.json().then(rs => {
            if (rs) {
                 auth.signIn(rs);
            }
        });


        console.log("++++++++++++++++++", result);
    };

    return (
        <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => console.log('Login Failed')}
        />
    );
};

export default GoogleLoginButton;
